import { useCallback } from 'react';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { LoyaltyInRestaurantIncentiveType } from 'generated/graphql-gateway';
import { useCart } from 'hooks/use-cart';
import { actions, useAppDispatch } from 'state/global-state';
import { t } from 'state/intl/translations';
import { RewardRedemptionMethod } from 'state/loyalty/hooks/types';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { useInRestaurantRedemptionContext } from 'state/loyalty/in-restaurant-redemption';

import { useAppliedReward } from './use-applied-reward';

export const RemoveRewardButton = () => {
  const { loyaltyUser } = useLoyaltyUser();
  const dispatch = useAppDispatch();
  const { removeFromCart } = useCart();
  const reward = useAppliedReward();
  const {
    inRestaurantRedemptionCart,
    removeInRestaurantRedemptionEntry,
  } = useInRestaurantRedemptionContext();

  const handleRemove = useCallback(() => {
    if (!reward) {
      return;
    }

    if (reward.redemptionMethod === RewardRedemptionMethod.IN_RESTAURANT) {
      const inRestaurantCartEntry = inRestaurantRedemptionCart.find(
        ({ details, type }) =>
          type === LoyaltyInRestaurantIncentiveType.REWARD && details.reward._id === reward.rewardId
      );

      if (inRestaurantCartEntry) {
        removeInRestaurantRedemptionEntry(inRestaurantCartEntry);
      }
    } else {
      if (reward.loyaltyEngineId) {
        dispatch(
          actions.loyalty.unApplyReward({
            cartId: reward.cartId,
            rewardBenefitId: reward.loyaltyEngineId,
            loyaltyUser,
          })
        );
      }

      removeFromCart({ cartId: reward.cartId });
    }
  }, [
    dispatch,
    loyaltyUser,
    reward,
    removeFromCart,
    removeInRestaurantRedemptionEntry,
    inRestaurantRedemptionCart,
  ]);

  return (
    <ActionButton
      variant={ActionButtonVariants.OUTLINE}
      size={ActionButtonSizes.SMALL}
      onPress={handleRemove}
    >
      {t('remove')}
    </ActionButton>
  );
};
